const legacyLocalStorageKeys = [
  'redirectRoute',
  'overviewStore',
  'savedName',
  'userProfile',
  'dataBank',
  'driver'
] as const;
type LegacyLocalStorageKey = (typeof legacyLocalStorageKeys)[number];

/**
 * This util class is written to:
 * - To prevent the application from crashing in case the localStorage quota is exceeded.
 * - To facilitate the process of switching to an alternative storage mechanism other than localStorage.
 *
 * @deprecated Use {@link localStorageService} instead.
 */
export class LocalStorageUtil {
  static hasKey(key: LegacyLocalStorageKey) {
    return key in window.localStorage;
  }

  static getItem(key: LegacyLocalStorageKey) {
    return window.localStorage.getItem(key);
  }

  static getItemObject(key: LegacyLocalStorageKey) {
    return this.hasKey(key) ? JSON.parse(this.getItem(key)) : null;
  }

  static setItem(key: LegacyLocalStorageKey, value: string) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.warn(
        `Unable to set localStorage item value for key "${key}", removing the item to prevent getting in an invalid state.`,
        error
      );
      this.removeItem(key);
    }
  }

  static setItemObject(key: LegacyLocalStorageKey, value: Object) {
    this.setItem(key, JSON.stringify(value));
  }

  static removeItem(key: LegacyLocalStorageKey) {
    return window.localStorage.removeItem(key);
  }
}
